/* eslint-disable @nx/enforce-module-boundaries */
import { MultiDropDownConfig } from '@hyper-inferno/drop-down-multiple-choice-core';
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';

export class DropDownMultipleChoiceHandler
  implements QuestionHandler<MultiDropDownConfig>
{
  async buildConfig(el: any, ctx: ITransformationContext) {
    const options = await ctx.listBuilding.getOptionsByListId(
      el.config.list_id,
      ctx,
      el.config.randomize_options,
    );

    return {
      ...el.config,
      options,
    };
  }
}
